export const PREVIOUS_LOAN_ACCOUNT_INTERACTIONS = 'previousLoanAccountInteractions';

export const FROM_TIME = 'fromTime';

export const TO_TIME = 'toTime';

export const NUMBER_OF_ELEMENTS = {
  TWO: 2,
  THREE: 3
};
